import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { guacHttpClient } from "@/lib/http";
import { EvaluationBuild, HttpResponse } from "@/types";

export function useGetEvaluations() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["all-evaluations", currentCompanyId],
    queryFn: async () => {
      const path = `job-internal-configs/evaluations`;
      const res = await guacHttpClient.get<
        EvaluationBuild[],
        HttpResponse<EvaluationBuild[]>
      >(path);
      return res.data;
    },
  });
}
